import { useBaseStore } from "@/store/store";

export function useCall() {
  const call = useBaseStore((store) => store.call);
  return { call };
}
